module.exports = __webpack_public_path__ + "img/monitoring.85d3c740.png";